<h3 mat-dialog-title class="title">
    {{ data.title}}
</h3>

<mat-dialog-content>
    <div class="fields">
        <txp-message *ngIf="warningMessage"
                     [type]="messageType.WARNING"
                     class="version-warning-message"
                     data-qa-label="MenuVersionWarning">
            {{ warningMessage | translate }}
        </txp-message>
        <mat-form-field *ngIf="data.input && !data.scheduleOnly">
            <mat-label>{{ data.inputLabel }}</mat-label>
            <input [formControl]="versionNameControl"
                   data-qa-label="TemplateName"
                   required
                   *ngIf="!data.scheduleOnly"
                   matInput />
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>
        <span *ngIf="data.input && data.scheduleOnly" class="version-number">{{ data.inputLabel}} : {{ data.versionName}}</span>

        <span *ngIf="data.versionNumber && !data.scheduleOnly"
              class="version-number">
            {{ data.versionNumber}}
        </span>

        <div *ngIf="data.checkbox" class="acknowledge-input">
            <mat-checkbox data-qa-label="ConfirmCheckbox"
                          [formControl]="scheduleTimeCheckboxControl">
                          {{data.checkboxLabel}}
            </mat-checkbox>
        </div>

        <div class="content" [hidden]="data.checkbox">
            {{ 'catalog.changeSets.scheduledDateDialog.message' | translate }}
        </div>

        <mat-form-field [hidden]="data.checkbox && !scheduleTimeCheckboxControl.value">
            <mat-label>{{ 'catalog.changeSets.scheduledDateDialog.label' | translate }}</mat-label>
            <input #scheduleDateInput
                   matInput
                   [min]="minDate"
                   [formControl]="scheduleDateControl"
                   (dateChange)="onScheduleDateChange($event)"
                   [ngxMatDatetimePicker]="dateForSchedule"
                   required>
            <mat-hint>
                {{ 'catalog.changeSets.scheduledDateDialog.hint' | translate }}
            </mat-hint>
            <mat-error *ngIf="scheduleDateControl.hasError('matDatetimePickerMin')">
                {{ 'catalog.changeSets.scheduledDateDialog.error.minDate' | translate }}
            </mat-error>
            <mat-error *ngIf="scheduleDateControl.hasError('required') && scheduleDateInput.value">
                {{ 'catalog.changeSets.scheduledDateDialog.error.invalid' | translate }}
            </mat-error>
            <mat-error *ngIf="scheduleDateControl.hasError('required') && !scheduleDateInput.value">
                {{ 'catalog.changeSets.scheduledDateDialog.error.required' | translate }}
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="$any(dateForSchedule)">
            </mat-datepicker-toggle>
            <ngx-mat-datetime-picker #dateForSchedule
                                     [showSpinners]="true"
                                     [color]="color"
                                     [enableMeridian]="true">
                <ngx-mat-datepicker-actions>
                    <button color="primary" ngxMatDatepickerApply mat-icon-button
                        [attr.aria-label]="'form.button.select' | translate ">
                        <i class="tce-icon-checkmark"></i>
                    </button>
                </ngx-mat-datepicker-actions>
            </ngx-mat-datetime-picker>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <txp-button (click)="onCancel()"
                data-qa-label="CancelButton"
                [style]="buttonStyle.SECONDARY">
        {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button data-qa-label="ContinueButton"
                [style]="buttonStyle.PRIMARY"
                (click)="onSave()"
                [disabled]="isSaveDisabled">
        {{ 'form.button.save' | translate }}
    </txp-button>
</mat-dialog-actions>